import { Pagination } from 'technical/hooks/usePagination';

export const benchTypeKeys = {
  all: [{ scope: 'benchType' }] as const,
  lists: () => [{ ...benchTypeKeys.all[0], entity: 'list' }] as const,
  list: (page: Pagination, search: null) =>
    [{ ...benchTypeKeys.lists()[0], search, page }] as const,
};
